export const inputCls =
  "w-28 rounded border border-line bg-canvas px-2 py-1 text-right text-[12px] text-fg outline-none focus:border-accent";
export const rowCls = "flex items-center justify-between gap-3 py-1";
export const groupCls = "rounded-md border border-line bg-canvas/40 p-2.5";
export const capCls =
  "mb-1 block text-[11px] font-semibold uppercase tracking-wide text-faint";

export const stateLabel = (st: string) =>
  st === "NA" ? "Outside the 50 states" : st;

export function priceRows(
  states: string[],
  title: string,
  values: Record<string, string>,
  set: (v: Record<string, string>) => void,
) {
  return (
    <div className={groupCls}>
      <span className={capCls}>{title}</span>
      {states.map((st) => (
        <div key={st} className={rowCls}>
          <span className="text-[12px] text-fg">{stateLabel(st)}</span>
          <span className="flex items-center gap-1">
            <span className="text-[12px] text-muted">$</span>
            <input
              className={inputCls}
              value={values[st] ?? ""}
              onChange={(e) => set({ ...values, [st]: e.target.value })}
              aria-label={`${title} ${st}`}
              inputMode="decimal"
            />
          </span>
        </div>
      ))}
    </div>
  );
}

export function numRow(
  label: string,
  value: string,
  onChange: (v: string) => void,
  prefix?: string,
) {
  return (
    <div className={rowCls}>
      <span className="text-[12px] text-fg">{label}</span>
      <span className="flex items-center gap-1">
        {prefix && <span className="text-[12px] text-muted">{prefix}</span>}
        <input
          className={inputCls}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          aria-label={label}
          inputMode="decimal"
        />
      </span>
    </div>
  );
}
